import IconFilters from '@assets/icons/filters.svg?react';
import { IconButton, useTheme } from '@mui/material';
import {
 GridColumnHeaderParams,
 useGridApiContext,
} from '@mui/x-data-grid-premium';
import { MutableRefObject } from 'react';

import customColors from '../../../utils/customColors';
import { CustomGridApi } from './types';

const HeaderFilterIcon = ({
 field,
 counter,
 onClick,
}: {
 field: string;
 counter?: number;
 onClick?: (
  params: GridColumnHeaderParams,
  event: React.MouseEvent<HTMLButtonElement>,
 ) => void;
}) => {
 const th = useTheme();
 const apiRef = useGridApiContext() as MutableRefObject<CustomGridApi>;
 const currentFilters = apiRef.current.state.filter.filterModel.items;
 const hasFilter = currentFilters.some((filter) => filter.field === field);

 return (
  (counter || hasFilter) && (
   <IconButton
    onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
     event.preventDefault();
     event.stopPropagation();
     apiRef.current.setFilterMenuState({
      anchorElement: event.currentTarget,
      colName: field,
     });
    }}
    sx={{
     '& path': {
      stroke: customColors.blue,
     },
    }}
   >
    <IconFilters />
   </IconButton>
  )
 );
};
export default HeaderFilterIcon;

